var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05_\u767B\u8D26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42,8.67H38V6a2,2,0,0,0-2-2H28a2,2,0,0,0-2,2V8.67H22a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H42a2,2,0,0,0,2-2v-8A2,2,0,0,0,42,8.67ZM34.14,15.6a3,3,0,1,1,0-4.24A3,3,0,0,1,34.14,15.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54,12H50a2,2,0,0,0-2,2v8a2,2,0,0,1-2,2H18a2,2,0,0,1-2-2V14a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2V58a2,2,0,0,0,2,2H54a2,2,0,0,0,2-2V14A2,2,0,0,0,54,12ZM44.3,38.18,30.16,52.32a2,2,0,0,1-2.53.24,1.92,1.92,0,0,1-.32-.26l-8.48-8.48A2,2,0,1,1,21.66,41l7.09,7.09L41.48,35.35a2,2,0,1,1,2.82,2.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.014292ad.svg";
export { ForwardRef as ReactComponent };